module.exports = __webpack_public_path__ + "static/media/b5.67353d5f.PNG";